const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns all available loots.
 */

function fetchTradingCampaign(apiUrl, urlAliasOrId, { country } = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `v2/trading/campaign/${urlAliasOrId}`,
    query: { lang: getApiLanguage(), country },
    expectedStatus: 200,
    description: 'Fetching trading campaign',
  });
}

function tradeCards(apiUrl, token, campaignId, tradingRewardTypeId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/trading/campaign/${campaignId}/${tradingRewardTypeId}`,
    query: { lang: getApiLanguage() },
    expectedStatus: 201,
    description: 'Exchanging cards in trading campaign',
  });
}

function fetchCampaignBalance(apiUrl, token, campaignId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: `v1/trading/campaign/${campaignId}/balance`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching user balance for campaign',
  });
}

function exchangeCardsForBalance(apiUrl, token, campaignId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: `v1/trading/campaign/${campaignId}/exchange`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Exchanging cards from inventory for campaign currency',
  });
}

module.exports = {
  fetchTradingCampaign,
  tradeCards,
  fetchCampaignBalance,
  exchangeCardsForBalance,
};
